"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
// Settings
var settings_component_1 = require("./settings/settings.component");
// Jobs
var new_job_component_1 = require("./jobs/new-job.component");
var jobs_component_1 = require("./jobs/jobs.component");
var job_detail_component_1 = require("./jobs/job-detail.component");
var edit_job_component_1 = require("./jobs/edit-job.component");
var hauler_shares_component_1 = require("./jobs/hauler-shares/hauler-shares.component");
var invitation_component_1 = require("./invitation/invitation.component");
var driver_invitation_component_1 = require("./invitation/driver-invitation.component");
var organization_invitation_component_1 = require("./invitation/organization-invitation.component");
var connections_component_1 = require("./connections/connections.component");
// Drivers
var driver_details_page_page_1 = require("./drivers/driver-details-page/driver-details-page.page");
// Fleet
var fleet_component_1 = require("./fleet/fleet.component");
// Accounts
var accounts_component_1 = require("./accounts/accounts.component");
var account_fleet_component_1 = require("./accounts/account-fleet.component");
var account_component_1 = require("./accounts/account.component");
var login_component_1 = require("./login/login.component");
var job_invitations_component_1 = require("./job-invitations/job-invitations.component");
var daily_board_component_1 = require("./daily-board/daily-board.component");
var project_list_component_1 = require("./project-list/project-list.component");
var new_project_component_1 = require("./project-list/new-project.component");
var team_component_1 = require("./team/team.component");
var styleguide_component_1 = require("./styleguide/styleguide.component");
var password_reset_component_1 = require("./password-reset/password-reset.component");
// Dispatching
var dispatch_component_1 = require("./dispatch/dispatch.component");
var dispatch_schedule_component_1 = require("./dispatch/schedule/dispatch-schedule.component");
var mobile_dispatch_assign_component_1 = require("./dispatch/mobile/mobile-dispatch-assign.component");
// Invoices
var edit_invoice_component_1 = require("./invoices/edit-invoice.component");
var invoices_component_1 = require("./invoices/invoices.component");
var invoice_component_1 = require("./invoices/invoice.component");
var create_invoice_component_1 = require("./invoices/create-invoice.component");
// Purchase Orders
var purchase_orders_component_1 = require("./purchase-orders/purchase-orders.component");
var purchase_order_component_1 = require("./purchase-orders/purchase-order.component");
// Assignments
var confirm_assignment_component_1 = require("./assignments/confirm-assignment.component");
var all_driver_assignments_component_1 = require("./assignments/all-driver-assignments/all-driver-assignments.component");
// Dashboard
var dashboard_component_1 = require("./dashboard/dashboard.component");
var auth_guard_1 = require("./guards/auth.guard");
// import { DriverGuard } from './guards/driver.guard';
var anyone_guard_1 = require("./guards/anyone.guard");
var leased_orgs_guard_1 = require("./guards/leased-orgs.guard");
var dispatch_guard_1 = require("./guards/dispatch.guard");
// Prices
var prices_component_1 = require("./prices/prices.component");
// Pay Records
var pay_sheets_component_1 = require("./pay-sheets/pay-sheets.component");
var driver_pay_component_1 = require("./pay-sheets/driver/driver-pay.component");
// Orders
var order_summary_status_component_1 = require("./orders/order-summary-status/order-summary-status.component");
var order_ticket_list_component_1 = require("./orders/order-ticket-list/order-ticket-list.component");
var fleet_health_component_1 = require("./fleet/health/fleet-health.component");
var trackables_component_1 = require("./trackables/trackables.component");
var ɵ0 = function () { return Promise.resolve().then(function () { return require("./advanced-billing/advanced-billing.module.ngfactory"); }).then(function (m) { return m.AdvancedBillingModuleNgFactory; }); }, ɵ1 = function () { return Promise.resolve().then(function () { return require("./locations/locations.module.ngfactory"); }).then(function (m) { return m.LocationsModuleNgFactory; }); }, ɵ2 = function () { return Promise.resolve().then(function () { return require("./locations/locations.module.ngfactory"); }).then(function (m) { return m.LocationsModuleNgFactory; }); }, ɵ3 = function () { return Promise.resolve().then(function () { return require("./plant-manager/plant-manager.module.ngfactory"); }).then(function (m) { return m.PlantManagerModuleNgFactory; }); }, ɵ4 = { view: { stub: 'trucks', title: 'Trucks', type: 'main' } }, ɵ5 = { view: { stub: 'trucks', title: 'Trucks', type: 'archive' } }, ɵ6 = { view: { stub: 'drivers', title: 'Drivers', type: 'main' } }, ɵ7 = { view: { stub: 'drivers', title: 'Drivers Health', type: 'main' } }, ɵ8 = { view: { stub: 'drivers', title: 'Drivers', type: 'archive' } }, ɵ9 = { view: { stub: 'trackables', title: 'Trackables' } }, ɵ10 = { view: { stub: 'trucks', title: 'Trucks' } }, ɵ11 = { view: { stub: 'drivers', title: 'Drivers' } }, ɵ12 = { view: { stub: 'trucks', title: 'Trucks' } }, ɵ13 = { view: { stub: 'drivers', title: 'Drivers' } }, ɵ14 = { view: { stub: 'trucks', title: 'Trucks' } }, ɵ15 = { view: { stub: 'drivers', title: 'Drivers' } }, ɵ16 = function () { return Promise.resolve().then(function () { return require("./trips/trips.module.ngfactory"); }).then(function (m) { return m.TripsModuleNgFactory; }); }, ɵ17 = function () { return Promise.resolve().then(function () { return require("./cyber-trips/cyber-trips.module.ngfactory"); }).then(function (m) { return m.CyberTripsModuleNgFactory; }); }, ɵ18 = function () { return Promise.resolve().then(function () { return require("./trips/trip-history/trip-history.module.ngfactory"); }).then(function (m) { return m.TripHistoryModuleNgFactory; }); }, ɵ19 = function () { return Promise.resolve().then(function () { return require("./punch-cards/punch-cards.module.ngfactory"); }).then(function (m) { return m.PunchCardsModuleNgFactory; }); }, ɵ20 = function () { return Promise.resolve().then(function () { return require("./surcharge-templates/surcharge-templates.module.ngfactory"); }).then(function (m) { return m.SurchargeTemplatesModuleNgFactory; }); }, ɵ21 = function () { return Promise.resolve().then(function () { return require("./work-orders/work-orders.module.ngfactory"); }).then(function (m) { return m.WorkOrdersModuleNgFactory; }); }, ɵ22 = function () { return Promise.resolve().then(function () { return require("./expenses/expenses.module.ngfactory"); }).then(function (m) { return m.ExpensesModuleNgFactory; }); }, ɵ23 = function () { return Promise.resolve().then(function () { return require("./paystubs/paystubs.module.ngfactory"); }).then(function (m) { return m.PaystubsModuleNgFactory; }); }, ɵ24 = function () { return Promise.resolve().then(function () { return require("./customers/customers.module.ngfactory"); }).then(function (m) { return m.CustomersModuleNgFactory; }); }, ɵ25 = function () { return Promise.resolve().then(function () { return require("./marketplace/marketplace.module.ngfactory"); }).then(function (m) { return m.MarketplaceModuleNgFactory; }); }, ɵ26 = function () { return Promise.resolve().then(function () { return require("./collaborators/collaborators.module.ngfactory"); }).then(function (m) { return m.CollaboratorsModuleNgFactory; }); }, ɵ27 = function () { return Promise.resolve().then(function () { return require("./tickets/tickets.module.ngfactory"); }).then(function (m) { return m.TicketsModuleNgFactory; }); }, ɵ28 = function () { return Promise.resolve().then(function () { return require("./replay/ruckit-replay.module.ngfactory"); }).then(function (m) { return m.RuckitReplayModuleNgFactory; }); }, ɵ29 = function () { return Promise.resolve().then(function () { return require("./driver-reports/driver-reports.module.ngfactory"); }).then(function (m) { return m.DriverReportsModuleNgFactory; }); }, ɵ30 = function () { return Promise.resolve().then(function () { return require("./shifts/shifts.module.ngfactory"); }).then(function (m) { return m.ShiftsModuleNgFactory; }); }, ɵ31 = function () { return Promise.resolve().then(function () { return require("./notifications/notifications.module.ngfactory"); }).then(function (m) { return m.NotificationsModuleNgFactory; }); }, ɵ32 = function () { return Promise.resolve().then(function () { return require("./reports/end-of-day/end-of-day.module.ngfactory"); }).then(function (m) { return m.EndOfDayModuleNgFactory; }); }, ɵ33 = function () { return Promise.resolve().then(function () { return require("./resources/resources.module.ngfactory"); }).then(function (m) { return m.ResourcesModuleNgFactory; }); }, ɵ34 = function () { return Promise.resolve().then(function () { return require("./control-reports/control-reports.module.ngfactory"); }).then(function (m) { return m.ControlReportsModuleNgFactory; }); };
exports.ɵ0 = ɵ0;
exports.ɵ1 = ɵ1;
exports.ɵ2 = ɵ2;
exports.ɵ3 = ɵ3;
exports.ɵ4 = ɵ4;
exports.ɵ5 = ɵ5;
exports.ɵ6 = ɵ6;
exports.ɵ7 = ɵ7;
exports.ɵ8 = ɵ8;
exports.ɵ9 = ɵ9;
exports.ɵ10 = ɵ10;
exports.ɵ11 = ɵ11;
exports.ɵ12 = ɵ12;
exports.ɵ13 = ɵ13;
exports.ɵ14 = ɵ14;
exports.ɵ15 = ɵ15;
exports.ɵ16 = ɵ16;
exports.ɵ17 = ɵ17;
exports.ɵ18 = ɵ18;
exports.ɵ19 = ɵ19;
exports.ɵ20 = ɵ20;
exports.ɵ21 = ɵ21;
exports.ɵ22 = ɵ22;
exports.ɵ23 = ɵ23;
exports.ɵ24 = ɵ24;
exports.ɵ25 = ɵ25;
exports.ɵ26 = ɵ26;
exports.ɵ27 = ɵ27;
exports.ɵ28 = ɵ28;
exports.ɵ29 = ɵ29;
exports.ɵ30 = ɵ30;
exports.ɵ31 = ɵ31;
exports.ɵ32 = ɵ32;
exports.ɵ33 = ɵ33;
exports.ɵ34 = ɵ34;
exports.routes = [
    // Dashboard
    { path: '', component: dashboard_component_1.DashboardComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'dashboard', component: dashboard_component_1.DashboardComponent, canActivate: [auth_guard_1.AuthGuard] },
    /*
     * New Modules
     */
    // Advanced Billing
    { path: 'billing-rates', loadChildren: ɵ0 },
    // Locations
    { path: 'locations', loadChildren: ɵ1 },
    { path: 'jobs/locations', loadChildren: ɵ2 },
    // Plant Manager
    { path: 'plant-manager', loadChildren: ɵ3 },
    // Settings
    { path: 'settings', component: settings_component_1.SettingsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'settings/:area', component: settings_component_1.SettingsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'settings/:area/:id/:tab', component: settings_component_1.SettingsComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Invitations
    { path: 'invitations', component: invitation_component_1.InvitationComponent },
    { path: 'invitations/:invite_code', component: invitation_component_1.InvitationComponent },
    { path: 'invitations/:invite_code/:step', component: invitation_component_1.InvitationComponent },
    { path: 'driver-invitations/:invite_code', component: driver_invitation_component_1.DriverInvitationComponent },
    { path: 'driver-invitations/:invite_code/:step', component: driver_invitation_component_1.DriverInvitationComponent },
    { path: 'create-organization/:invite_code', component: organization_invitation_component_1.OrganizationInvitationComponent },
    { path: 'create-organization/:invite_code/:step', component: organization_invitation_component_1.OrganizationInvitationComponent },
    // Connections
    { path: 'connections', component: connections_component_1.ConnectionsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'connections/:type', component: connections_component_1.ConnectionsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'connections/:type/:search', component: connections_component_1.ConnectionsComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Fleet
    {
        path: 'trucks', component: fleet_component_1.FleetComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ4
    },
    {
        path: 'trucks/:status', component: fleet_component_1.FleetComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ5
    },
    {
        path: 'drivers', component: fleet_component_1.FleetComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ6
    },
    {
        path: 'drivers/:id/details', component: driver_details_page_page_1.DriverDetailsPage, canActivate: [auth_guard_1.AuthGuard]
    },
    {
        path: 'drivers/:id/details/:tab', component: driver_details_page_page_1.DriverDetailsPage, canActivate: [auth_guard_1.AuthGuard]
    },
    {
        path: 'fleet-health', component: fleet_health_component_1.FleetHealthComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ7
    },
    {
        path: 'drivers/:status', component: fleet_component_1.FleetComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ8
    },
    {
        path: 'trackables', component: trackables_component_1.TrackablesComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ9
    },
    // Leased Fleet
    { path: 'leased-fleet', component: accounts_component_1.AccountsComponent, canActivate: [leased_orgs_guard_1.LeasedOrgsGuard] },
    { path: 'leased-fleet/new', component: account_component_1.AccountComponent, canActivate: [leased_orgs_guard_1.LeasedOrgsGuard] },
    { path: 'leased-fleet/:accountId/edit', component: account_component_1.AccountComponent, canActivate: [leased_orgs_guard_1.LeasedOrgsGuard] },
    {
        path: 'leased-fleet/trucks', component: account_fleet_component_1.AccountFleetComponent, canActivate: [leased_orgs_guard_1.LeasedOrgsGuard],
        data: ɵ10
    },
    {
        path: 'leased-fleet/drivers', component: account_fleet_component_1.AccountFleetComponent, canActivate: [leased_orgs_guard_1.LeasedOrgsGuard],
        data: ɵ11
    },
    {
        path: 'leased-fleet/trucks/:accountId', component: account_fleet_component_1.AccountFleetComponent, canActivate: [leased_orgs_guard_1.LeasedOrgsGuard],
        data: ɵ12
    },
    {
        path: 'leased-fleet/drivers/:accountId', component: account_fleet_component_1.AccountFleetComponent, canActivate: [leased_orgs_guard_1.LeasedOrgsGuard],
        data: ɵ13
    },
    // Accounts
    { path: 'accounts', component: accounts_component_1.AccountsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'accounts/new', component: account_component_1.AccountComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'accounts/:accountId/edit', component: account_component_1.AccountComponent, canActivate: [auth_guard_1.AuthGuard] },
    {
        path: 'accounts/trucks/:accountId', component: account_fleet_component_1.AccountFleetComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ14
    },
    {
        path: 'accounts/drivers/:accountId', component: account_fleet_component_1.AccountFleetComponent, canActivate: [auth_guard_1.AuthGuard],
        data: ɵ15
    },
    // Trips
    { path: 'trips', loadChildren: ɵ16 },
    { path: 'geotrips', loadChildren: ɵ17 },
    // TripHistory
    { path: 'trips/:id', loadChildren: ɵ18 },
    // Punchcards
    { path: 'punchcards', loadChildren: ɵ19 },
    // Jobs
    { path: 'jobs', component: jobs_component_1.JobsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/all', component: jobs_component_1.JobsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/drivers', component: all_driver_assignments_component_1.AllDriverAssignmentsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/new', component: new_job_component_1.NewJobComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/daily', component: daily_board_component_1.DailyBoardComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/daily/:table', component: daily_board_component_1.DailyBoardComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'daily', component: daily_board_component_1.DailyBoardComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'daily/:table', component: daily_board_component_1.DailyBoardComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/clone/:jobId', component: new_job_component_1.NewJobComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/:jobId/clone', component: new_job_component_1.NewJobComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/:id/edit', component: edit_job_component_1.EditJobComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/hauler-shares', component: hauler_shares_component_1.HaulerSharesComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/pending', component: job_invitations_component_1.JobInvitationsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/pending/:invitationId', component: job_invitations_component_1.JobInvitationsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/:jobId', component: job_detail_component_1.JobDetailComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'jobs/:jobId/:jobEventId', component: job_detail_component_1.JobDetailComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'project-list', component: project_list_component_1.ProjectListComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'projects/:id/new-job', component: new_job_component_1.NewJobComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'projects/new', component: new_project_component_1.NewProjectComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Dispatching
    { path: 'dispatch-schedule', component: dispatch_schedule_component_1.DispatchScheduleComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'dispatch', component: dispatch_component_1.DispatchComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'dispatch/:jobId', component: dispatch_component_1.DispatchComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'dispatch/:jobId/:jobEventId', component: dispatch_component_1.DispatchComponent, canActivate: [auth_guard_1.AuthGuard, dispatch_guard_1.DispatchGuard] },
    { path: 'dispatch/:jobId/:jobEventId/:panel', component: mobile_dispatch_assign_component_1.MobileDispatchAssignComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Invoices
    { path: 'invoices/:id/edit', component: edit_invoice_component_1.EditInvoiceComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'invoices', component: invoices_component_1.InvoicesComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'invoices/filter/:state', component: invoices_component_1.InvoicesComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'invoices/:jobId/trips', component: create_invoice_component_1.CreateInvoiceComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'invoices/:id', component: invoice_component_1.InvoiceComponent },
    { path: 'invoices/:id/preview', component: invoice_component_1.InvoiceComponent },
    // Surcharges
    {
        path: 'surcharge-templates',
        loadChildren: ɵ20
    },
    // Work Orders
    { path: 'work-orders', loadChildren: ɵ21 },
    // Expenses
    { path: 'expenses', loadChildren: ɵ22 },
    // Paystubs
    { path: 'paystubs', loadChildren: ɵ23 },
    // Purchase Orders
    { path: 'purchase-orders', component: purchase_orders_component_1.PurchaseOrdersComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'purchase-orders/new', component: purchase_order_component_1.PurchaseOrderComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'purchase-orders/:id/edit', component: purchase_order_component_1.PurchaseOrderComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Prices
    { path: 'prices', component: prices_component_1.PricesComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Customers
    { path: 'customers', loadChildren: ɵ24 },
    { path: 'team', component: team_component_1.TeamComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'login', component: login_component_1.LoginComponent },
    { path: 'logout', component: login_component_1.LoginComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'styleguide', component: styleguide_component_1.StyleguideComponent },
    { path: 'login/reset', component: password_reset_component_1.PasswordResetComponent },
    // Marketplace
    { path: 'marketplace', loadChildren: ɵ25 },
    // Collaborators
    {
        path: 'jobs/:jobId/:jobEventId/collaborators',
        loadChildren: ɵ26
    },
    // Tickets
    { path: '', loadChildren: ɵ27 },
    // Assignments
    { path: 'assignments/:id/confirm', component: confirm_assignment_component_1.ConfirmAssignmentComponent, canActivate: [anyone_guard_1.AnyoneGuard] },
    // Ruckit Replay
    { path: 'replay', loadChildren: ɵ28 },
    // Driver Pay
    { path: 'pay-reports/all', component: pay_sheets_component_1.PaySheetsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'pay-reports/:type', component: pay_sheets_component_1.PaySheetsComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'driver-pay/:id', component: driver_pay_component_1.DriverPayComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'driver-pay/:id/:type', component: driver_pay_component_1.DriverPayComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Orders
    { path: 'orders/:jobEventId', component: order_summary_status_component_1.OrderSummaryStatusComponent, canActivate: [auth_guard_1.AuthGuard] },
    { path: 'orders/:jobEventId/tickets', component: order_ticket_list_component_1.OrderTicketListComponent, canActivate: [auth_guard_1.AuthGuard] },
    // Driver Reports
    { path: 'driver-reports', loadChildren: ɵ29 },
    // Shifts
    { path: 'shifts', loadChildren: ɵ30 },
    // Notifications
    { path: 'notifications', loadChildren: ɵ31 },
    // End of Day Report
    { path: 'end-of-day-reports', loadChildren: ɵ32 },
    // Resources
    { path: 'resources', loadChildren: ɵ33 },
    // Control reports
    { path: 'control-reports', loadChildren: ɵ34 },
];
exports.routing = router_1.RouterModule.forRoot(exports.routes);
